import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
	standalone: true,
	selector: '[appNavigationTableEnleverFocusTabulation]'
})
export class NavigationTableEnleverFocusTabulationDirective implements AfterContentInit {
	constructor(private elementRef: ElementRef) {
	}

	ngAfterContentInit(): void {
		// On enlève le tabindex sur l'input pour éviter que le focus soit mis dessus lorsqu'on navigue avec les touches tabulation
		// On le fait dans un setTimeout pour être sûr que l'input soit bien chargé
		setTimeout(() => this.elementRef.nativeElement.querySelector('input').setAttribute('tabindex', '-1'), 10);
	}
}
